module.exports = __webpack_public_path__ + "img/yiyao.8625cacc.jpg";